export default __webpack_public_path__ + "f0c70cf47bcc593e5c85f97b25bb6096.svg";